import { Box, Typography } from '@mui/material';

interface Props {
  title: string;
  description?: string;
}

const StepTitle = ({ title, description }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, my: 2 }}>
      <Typography color="textPrimary" variant="subtitle1">
        {title}
      </Typography>
      {description ? (
        <Typography color="text.secondary" variant="body2">
          {description}
        </Typography>
      ) : null}
    </Box>
  );
};

export default StepTitle;
